const rootID = "ui_root";

export function getOrCreateRootDiv() {
  const root = document.getElementById(rootID);
  if (root) {
    return root;
  }

  const divElement = document.createElement("div");
  divElement.id = rootID;
  divElement.style.position = "fixed";
  divElement.style.left = "0px";
  divElement.style.top = "0px";
  divElement.style.width = "100%";
  divElement.style.height = "100%";
  divElement.tabIndex = -1;
  divElement.style.border = "none";
  divElement.style.outline = "none";
  divElement.style.zIndex = "100";
  divElement.autofocus = true;
  document.body.appendChild(divElement);
  return divElement;
}

export function disableInput(e: MouseEvent | TouchEvent | KeyboardEvent) {
  e.stopPropagation();
}
